import { render } from "./PreviewReceipt.vue?vue&type=template&id=2af3b538&scoped=true&ts=true"
import script from "./PreviewReceipt.vue?vue&type=script&lang=ts"
export * from "./PreviewReceipt.vue?vue&type=script&lang=ts"

import "./PreviewReceipt.vue?vue&type=style&index=0&id=2af3b538&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af3b538"]])

export default __exports__